import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router'; 

@Component({
  selector: 'app-error',
  templateUrl: './qr.error.component.html'
})

export class QrErrorComponent implements OnInit {
  errorData:any;
  constructor(
      private route: ActivatedRoute,
      private router: Router
      ) {
        this.route.queryParams.subscribe(params => {
             this.errorData = params;
             if(this.errorData.statusMsg == undefined)
             {
              this.errorData = {
                'statusMsg': 'Something Went Wrong'
              }
             }
        });
      }

  ngOnInit(): void {
  }
  redirectHome()
  {
    this.router.navigate(['/Envista']);
  }
}
